import { ApiProperty } from '@nestjs/swagger';
export class SaleOrderIdRequest {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    plantId?: number;
    @ApiProperty()
    itemSubCategoryId? : number;
    @ApiProperty()
    state? : string;
    @ApiProperty()
    isPreperationRequired? : string;  
    @ApiProperty()
    fromSaleOrder?:number;  
    @ApiProperty()
    jobType? : string;
}

